import { formatDate, parseUTCDate } from '../../../../util';
import React from 'react';
import { getCurrentShopifyOrderFromSubscription } from '../../../../extractFromState';
import { useSelector } from 'react-redux';
import { getSelectedSubscriptionList } from '../../../../selectors/tools';
import { Container, OrderField, FieldTitle, NotLastItem, LastItem, Column } from '../DTInfoWidget.styles';

const DTSubscriptionDetailsWidget = () => {
  const selectedSubscriptionList = useSelector(getSelectedSubscriptionList);
  const currentShopifyOrder = useSelector(getCurrentShopifyOrderFromSubscription);
  const shipped_date = currentShopifyOrder && currentShopifyOrder.shipped_date;

  return (
    <div>
      {selectedSubscriptionList.map((selectedSubscription, idx) => {
        const titleOrSku = selectedSubscription.variant_title || selectedSubscription.sku;

        return (
          <Container className="fs-block" key={idx}>
            <Column>
              <OrderField>
                {selectedSubscription.quantity} x {selectedSubscription.product_title} - {titleOrSku}
              </OrderField>
            </Column>
            <Column>
              {shipped_date && (
                <NotLastItem>
                  <FieldTitle>Most recent shipment:</FieldTitle>
                  {formatDate(parseUTCDate(currentShopifyOrder.shipped_date))}
                </NotLastItem>
              )}
              <LastItem>
                <FieldTitle>Next charge date:</FieldTitle>
                {selectedSubscription.next_charge_scheduled_at
                  ? formatDate(parseUTCDate(selectedSubscription.next_charge_scheduled_at))
                  : 'N/A'}
              </LastItem>
            </Column>
          </Container>
        );
      })}
    </div>
  );
};
export default DTSubscriptionDetailsWidget;
